import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { EmailAttachment } from './models/email-attachment.interface';

@Component({
  selector: 'app-email-attachments',
  templateUrl: './email-attachments.component.html',
  styleUrls: ['./email-attachments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailAttachmentsComponent {
  @Input()
  attachments: EmailAttachment[];

  @Output()
  public deleteAction: EventEmitter<EmailAttachment> = new EventEmitter();

  delete(attachment: EmailAttachment) {
    if (attachment.canDelete) {
      this.deleteAction.emit(attachment);
    }
  }
}
